import _ from 'lodash'
import React, {useState} from 'react'
import {OverlayTrigger, Popover} from 'react-bootstrap'
import IconWithHoverAndSelect from '../../playlist/components/PlayListTable/IconWithHoverAndSelect'
import PlayListRow from './PlayListRow'

interface InputProps {
  playLists: any
  commandInfo?: any
  selectedCommandData?: any
  ShowCommandInfo?: any 
}

const PlayListTable: React.FC<InputProps> = ({
  playLists,
  commandInfo,
  selectedCommandData,
  ShowCommandInfo,
}) => {
  const [selectedIcon, setSelectedIcon] = useState<string | null>('Play')
  const plists: any[] = []

  if (!ShowCommandInfo) {
    const showCommand = _.find(commandInfo, {Id: selectedCommandData?.command})

    if (showCommand?.Playlists && Array.isArray(showCommand.Playlists)) {
      _.forEach(showCommand.Playlists, (p: any) => {
        const found = _.find(playLists, {Id: p.PlaylistId})
        if (found) {
          plists.push({...found, CommandType: 'Default'})
        }
      })
    }
  } else {
    if (Array.isArray(ShowCommandInfo)) {
      ShowCommandInfo.forEach((cmd: any, index: number) => {
        if (cmd?.Playlists && Array.isArray(cmd.Playlists)) {
          _.forEach(cmd.Playlists, (p: any) => {
            const found = _.find(playLists, {Id: p.PlaylistId})
            if (found) {
              plists.push({
                ...found,
              })
            }
          })
        }
      })
    } else if (ShowCommandInfo?.Playlists && Array.isArray(ShowCommandInfo.Playlists)) {
      _.forEach(ShowCommandInfo.Playlists, (p: any) => {
        const found = _.find(playLists, {Id: p.PlaylistId})
        if (found) {
          plists.push({...found, CommandType: 'Single'})
        }
      })
    }
  }

  const sortedPlists = _.sortBy(plists, [
    (pl: any) => (pl.CommandType === 'High' ? 0 : pl.CommandType === 'Low' ? 1 : 2),
  ])

  const previewPopOver = (
    <Popover
      id='popover-preview-details'
      className='max-width-300px text-center'
      style={{fontSize: '0.925rem'}}
    >
      <Popover.Body>
        Choose how previews are shown.
        <br />
        <br />
        Start animation by hovering on image
        <br />
        Autoplay all animations
        <br />
        Show preview as images in order
      </Popover.Body>
    </Popover>
  )

  return (
    <div className={`card-body py-3 ${ShowCommandInfo ? 'bg-white' : ''}`}>
      <div className='table-responsive'>
        <table className='table align-middle table-row-bordered fs-6 gy-5 no-footer table-striped'>
          <thead>
            <tr className='fw-bolder'>
              <th>Id</th>
              <th>Title</th>
              <th>Description</th>
              <th>
                <div className='d-flex align-items-center'>
                  <React.Fragment>
                    <OverlayTrigger
                      trigger={['hover', 'focus', 'click']}
                      overlay={previewPopOver}
                      rootClose
                    >
                      <div>Preview</div>
                    </OverlayTrigger>
                    <div className='d-inline-flex align-items-center ml-8'>
                      <IconWithHoverAndSelect
                        selectedIcon={selectedIcon}
                        setSelectedIcon={setSelectedIcon}
                      />
                    </div>
                  </React.Fragment>
                </div>
              </th>
            </tr>
          </thead>
          <tbody className='text-dark fw-bold'>
            {sortedPlists?.map((pl: any, i: number) => (
              <PlayListRow
                key={`pl${i}`}
                playlist={pl}
                selectedIcon={selectedIcon}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default PlayListTable
